import {Col, Row} from "antd";
import {KBList} from "./KBList";
import {useEffect, useState} from "react";
import {
  getTopAlternateMedicineSearch,
  getTopDiseaseGeneSearch, getTopDiseaseLncRNASearch, getTopDiseaseMiRNASearch,
  getTopDiseaseSearch, getTopDrugDiseaseSearch, getTopDrugPDBSearch,
  getTopDrugSearch,
  getTopGeneSearch, getTopLncRNASearch,
  getTopMiRNASearch,
  getTopPDBSearch
} from "../Utils/api";

export const KBStats = ({ kbData, isKBLoading }) => {

  const [topDrugSearch, setTopDrugSearch] = useState([])
  const [topAlternateMedicineSearch, setTopAlternateMedicineSearch] = useState([])
  const [topDiseaseSearch, setTopDiseaseSearch] = useState([])
  const [topGeneSearch, setTopGeneSearch] = useState([])
  const [topPDBSearch, setTopPDBSearch] = useState([])
  const [topMiRNASearch, setTopMiRNASearch] = useState([])
  const [topLncRNASearch, setTopLncRNASearch] = useState([])
  const [topDiseaseGeneSearch, setTopDiseaseGeneSearch] = useState([])
  const [topDrugDiseaseSearch, setTopDrugDiseaseSearch] = useState([])
  const [topDrugPDBSearch, setTopDrugPDBSearch] = useState([])
  const [topDiseaseMiRNASearch, setTopDiseaseMiRNASearch] = useState([])
  const [topDiseaseLncRNASearch, setTopDiseaseLncRNASearch] = useState([])

  useEffect(() => {
    getTopAlternateMedicineSearch()
      .then(r => setTopAlternateMedicineSearch(r.data))
      .catch(e => console.log(e))
    getTopDrugSearch()
      .then(r => setTopDrugSearch(r.data))
      .catch(e => console.log(e))
    getTopDiseaseSearch()
      .then(r => setTopDiseaseSearch(r.data))
      .catch(e => console.log(e))
    getTopPDBSearch()
      .then(r => setTopPDBSearch(r.data))
      .catch(e => console.log(e))
    getTopMiRNASearch()
      .then(r => setTopMiRNASearch(r.data))
      .catch(e => console.log(e))
    getTopLncRNASearch()
      .then(r => setTopLncRNASearch(r.data))
      .catch(e => console.log(e))
    getTopGeneSearch()
      .then(r => setTopGeneSearch(r.data))
      .catch(e => console.log(e))
    getTopDiseaseGeneSearch()
      .then(r => setTopDiseaseGeneSearch(r.data))
      .catch(e => console.log(e))
    getTopDrugDiseaseSearch()
      .then(r => setTopDrugDiseaseSearch(r.data))
      .catch(e => console.log(e))
    getTopDrugPDBSearch()
      .then(r => setTopDrugPDBSearch(r.data))
      .catch(e => console.log(e))
    getTopDiseaseMiRNASearch()
      .then(r => setTopDiseaseMiRNASearch(r.data))
      .catch(e => console.log(e))
    getTopDiseaseLncRNASearch()
      .then(r => setTopDiseaseLncRNASearch(r.data))
      .catch(e => console.log(e))
  }, [])

  const data = [
    {name: 'Visitor Count', count: kbData.visits, link: false},
    {name: 'Drugs', count: kbData.drugs, link: '/drugs'},
    {name: 'Alternate Medicine', count: kbData.alternateMedicine, link: '/alternateMedicine'},
    {name: 'Diseases', count: kbData.diseases, link: '/diseases'},
    {name: 'Genes', count: kbData.genes, link: '/genes'},
    {name: 'miRNAs', count: kbData.miRNAs, link: '/miRNAs'},
    {name: 'lncRNAs', count: kbData.lncRNAs, link: '/lncRNAs'},
    {name: 'PDBs', count: kbData.PDBs, link: '/PDBs'},
    {name: 'Drug-Disease Pairs', count: kbData.drugDiseasePairs, link: '/drug-disease'},
    {name: 'Drug-PDB Pairs', count: kbData.drugPDBPairs, link: '/drug-pdb'},
    {name: 'Disease-Gene Pairs', count: kbData.diseaseGenePairs, link: '/disease-gene'},
    {name: 'Disease-miRNA Pairs', count: kbData.diseaseMiRNAPairs, link: '/disease-miRNA'},
    {name: 'Disease-lncRNA Pairs', count: kbData.diseaseLncRNAPairs, link: '/disease-lncRNA'},
  ]

  const kbState = {
    name: 'Knowledgebase Statistics',
    data: data
  }

  const widgets = [
    {name: 'Top Drug Searches', data: topDrugSearch, color: '#000', textColor: '#fff'},
    {name: 'Top Alternate Medicine Searches', data: topAlternateMedicineSearch, color: '#000', textColor: '#fff'},
    {name: 'Top Disease Searches', data: topDiseaseSearch, color: '#000', textColor: '#fff'},
    {name: 'Top Drug-Disease Searches', data: topDrugDiseaseSearch, color: '#000', textColor: '#fff'},
    {name: 'Top Gene Searches', data: topGeneSearch, color: '#000', textColor: '#fff'},
    {name: 'Top miRNA Searches', data: topMiRNASearch, color: '#000', textColor: '#fff'},
    {name: 'Top lncRNA Searches', data: topLncRNASearch, color: '#000', textColor: '#fff'},
    {name: 'Top PDB Searches', data: topPDBSearch, color: '#000', textColor: '#fff'},
    {name: 'Top Disease-Gene Searches', data: topDiseaseGeneSearch, color: '#000', textColor: '#fff'},
    {name: 'Top Disease-miRNA Searches', data: topDiseaseMiRNASearch, color: '#000', textColor: '#fff'},
    {name: 'Top Disease-lncRNA Searches', data: topDiseaseLncRNASearch, color: '#000', textColor: '#fff'},
    {name: 'Top Drug-PDB Searches', data: topDrugPDBSearch, color: '#000', textColor: '#fff'},
  ]

  return(
    <Row gutter={[20, 20]}>
      <Col lg={6} xs={24}>
        <KBList loading={isKBLoading} data={kbState} />
      </Col>
      <Col lg={18}>
        <Row gutter={[20, 20]}>
          {widgets.map(v => <Col key={v.name} lg={6} xs={24}>
            <KBList data={v} />
          </Col>)}
        </Row>
      </Col>
    </Row>
  )
}